import { Component, model } from '@angular/core';

@Component({
  selector: 'rid-klankbord-toggle',
  standalone: true,
  imports: [],
  templateUrl: './rid-klankbord-toggle.html',
  host: {
    class: 'block w-full',
  },
})
export class RidKlankbordToggle {
  value = model(false);

  onValueChange(event: Event) {
    this.value.set((event.target as HTMLInputElement).checked);
  }
}
